'use client';

import React, { useCallback, useState } from 'react';
import moment from 'moment';
import { Button } from 'reactstrap';
import { isEmpty } from 'lodash';
import type { ActivityLogEntry } from 'src/types';

interface ReachedOutToTenantEventAttr {
  reached_out_to_tenant_on?: string;
  [key: string]: unknown;
}

interface ReachedOutToTenantProps {
  activityLog: ActivityLogEntry;
  timeZone: string;
}

const ReachedOutToTenant: React.FC<ReachedOutToTenantProps> = ({ activityLog, timeZone }) => {
  const [showAll, setShowAll] = useState(false);

  const toggle = useCallback(() => setShowAll(!showAll), [showAll]);

  if (isEmpty(timeZone)) {
    return null;
  }

  const eventAttrs = activityLog?.event_attributes as unknown as ReachedOutToTenantEventAttr[] ;

  return (
    (Array.isArray(eventAttrs) && eventAttrs?.length > 1) ? (
      <React.Fragment>
        <p className="mb-0">
          {'Reached out '}
          <b>
            {`${eventAttrs?.length} times`}
          </b>
          {' to tenant'}
          {' '}
          {!showAll
            ? (
              <Button
                color="none"
                className="btn-link"
                onClick={toggle}
              >
                Show All
              </Button>
            ) : ''}
        </p>
        <ul className="mt-2">
          {showAll && eventAttrs?.map((item) => (
            <li key={item?.reached_out_to_tenant_on}>
              {moment?.utc(
                item?.reached_out_to_tenant_on,
              )?.tz(
                timeZone as string,
              )?.format('MMM DD, YYYY (h:mm a z)')}
            </li>
          ))}
        </ul>
        {showAll
          ? (
            <Button
              color="none"
              className="btn-link"
              onClick={toggle}
            >
              Show Less
            </Button>
          ) : ''}
      </React.Fragment>
    )
      : (
        <p>
          {`Reached out to tenant on ${
            moment.utc(
              (eventAttrs)?.[0]
                ?.reached_out_to_tenant_on,
            ).tz(timeZone)
              ?.format('MMM DD, YYYY (h:mm a)')
          }`}
        </p>
      )
  );
};

export default ReachedOutToTenant;
